import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const translationData = { messages: {}, numberFormats: {}, dateTimeFormats: {} }
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      translationData.messages[locale] = locales(key).messages
      translationData.numberFormats[locale] = locales(key).numberFormats
      translationData.dateTimeFormats[locale] = locales(key).dateTimeFormats
    }
  })
  return translationData
}

let i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  ...loadLocaleMessages(),
})

i18n.locale = localStorage.getItem('language') || navigator.language

//Fallback in case of unrecognized browser language
if (!i18n.availableLocales.includes(i18n.locale)) {
  i18n.locale = 'en'
}

export const locale = () => {
  return i18n.locale
}
export default i18n
